export default __webpack_public_path__ + "static/media/mail.80b23b18.svg";